
import {typesPwrreset} from './svtypes/pwrreset'


let initStore = {
    loading: false,
    error: false,

    my_data_pwrreset: {
        "email": ""
      
    },
    my_data_pwrreset_confirmation : {

        "status":"OK",
        "reguserId":"UU12345",
        "saveDate":"Jan 3027"
    }
   
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        case 'GET_PWRRESET_SUCCESS':
            console.log("reduce %%%%%%%%evpwrreset success*****************");
            console.log(action.payload.my_data_pwrreset_confirmation);
            // let januState = {...state, loading: false, my_data_pwrreset: action.payload.my_data_pwrreset}
             januState = {...state, loading: false, my_data_pwrreset: action.payload.my_data_pwrreset_confirmation}
            return januState

        case typesPwrreset.GET_PWRRESET_SUCCESS:
            console.log("reduce %%%%%%%%evpwrreset success*****************");
            console.log(action.payload.my_data_pwrreset_confirmation);
            // let januState = {...state, loading: false, my_data_pwrreset: action.payload.my_data_pwrreset}
             januState = {...state, loading: false, my_data_pwrreset: action.payload.my_data_pwrreset_confirmation}
            return januState
      
        case typesPwrreset.GET_PWRRESET_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesPwrreset.GET_PWRRESET_ERROR:
            console.log("error")
            return {...state, error: true}
        
        
        default:
            return state
    }
}